export enum TradingGroupLevelsEnum {
    All,
    Firm,
    Tenant
}
